import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import './Login.css';

export default function ForgotPassword({ forgotData, setForgotData, onBack }) {
    const [loading, setLoading] = useState(false);

    // Clear fields when the component mounts or the user navigates back
    useEffect(() => {
        // Reset forgotData to ensure fields are empty when navigating back
        setForgotData({ email: '', pan: '' });
    }, [setForgotData]);

    // Handle input change for email
    const handleChange = (e) => {
        setForgotData({ ...forgotData, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = () => {
        const { email } = forgotData;

        // Validate if email is entered
        if (!email) {
            return Swal.fire({
                icon: 'warning',
                title: 'Email required',
                text: 'Please enter your Registered email.',
            });
        }

        setLoading(true);

        // Send the data to the backend API
        axios.post('https://django-backend-115705416374.asia-south1.run.app/api/password-reset/', {
            // axios.post('http://localhost:8000/api/password-reset/', {
            email: email
        })
            .then(res => {
                // Success message when OTP is sent successfully
                Swal.fire({
                    icon: 'success',
                    title: 'OTP Sent',
                    text: res.data.message || 'Check your email for the OTP link.',
                });
                // Clear the fields after a successful submission
                setForgotData({ email: '', pan: '' });
            })
            .catch(err => {
                // Error message when there is a failure (e.g., invalid email)
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: err.response?.data?.error || 'Failed to send OTP. Check your inputs.',
                }).then(() => {
                    // Clear fields after error popup is closed
                    setForgotData({ email: '', pan: '' });
                });
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="auth-box forgot-box">
            <div className="logos-container">
                <img draggable={false}
                    src={process.env.PUBLIC_URL + "/Main.png"}
                    alt="Main Logo"
                    className="logo"
                />
                <img draggable={false}
                    src={process.env.PUBLIC_URL + "/Invenia.png"}
                    alt="Invenia Logo"
                    className="logo logo-second"
                />
                <img draggable={false}
                    src={process.env.PUBLIC_URL + "/STL_Logo.png"}
                    alt="STL Logo"
                    className="logo logo-third"
                />
            </div>

            <h2>Forgot Password</h2>
            <input
                type="email"
                name="email"
                className="forgot-email"
                placeholder="Enter Your Registered Email"
                value={forgotData.email}
                onChange={handleChange}
                disabled={loading}
                readOnly={loading}
            />
            {/* PAN/TAN field removed */}
            <button onClick={handleSubmit} disabled={loading}>
                {loading ? 'Sending OTP...' : 'Send OTP'}
            </button>
            <p>
                Remembered your password? <button className="link-btn" onClick={() => !loading && onBack()} disabled={loading}>Login</button>
            </p>

            <div style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0', zIndex: 1000 }}>
                <span style={{ fontWeight: '600', color: '#fff', marginRight: '10px' }}>Powered by</span>
                <img draggable={false} src="/Main.png" alt="STL-DIGITAL" style={{ height: '30px' }} />
            </div>
        </div >
    );
}
